<template>
  <canvas width="100%" height="330"></canvas>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    labels: {},
    values: {},
    color: {
      default: "rgba(220,220,220,0.2)"
    }
  },
  methods: {
    reRenderChart() {
      let chartData = {
        labels: this.labels,
        datasets: [
          {
            label: "Subscribe",
            fill: false,
            borderColor: "#2980b9",
            borderWidth: 1,
            data: this.values.subscribed
          },
          {
            label: "Unsubscribe",
            fill: false,
            borderColor: "#e67e22",
            borderWidth: 1,
            data: this.values.unsubscribed
          }
        ]
      };

      new Chart(this.$el.getContext("2d"), {
        type: "line",
        data: chartData,
        options: {
          maintainAspectRatio: false,
          responsive: true,
          title: {
            display: false
          },
          legend: {
            display: true
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                  drawBorder: true,
                  drawTicks: true
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                  drawBorder: false,
                  drawTicks: true
                },
                ticks: {
                  min: 0
                }
              }
            ]
          }
        }
      });
    }
  },
  mounted() {
    this.reRenderChart();
  },
  watch: {
    values() {
      this.reRenderChart();
    }
  }
};
</script>